import { useAuth } from "@/_core/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { TrendingUp, FileText, Sparkles, ArrowRight } from "lucide-react";
import { APP_TITLE, getLoginUrl } from "@/const";
import { Link, useLocation } from "wouter";
import { useEffect } from "react";

export default function Home() {
  const { user, loading, isAuthenticated } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      setLocation("/dashboard");
    }
  }, [loading, isAuthenticated, setLocation]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">載入中...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-background via-background to-accent/10 p-4">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-2">
          <div className="flex justify-center mb-6">
            <div className="p-4 rounded-full bg-primary/10">
              <Sparkles className="h-10 w-10 text-primary" />
            </div>
          </div>
          <h1 className="text-3xl font-bold tracking-tight">
            悅庭牙醫 AEO 戰情中心
          </h1>
          <p className="text-muted-foreground">
            請登入以存取您的專屬儀表板
          </p>
        </div>

        <div className="pt-4">
          <a href={getLoginUrl()} className="w-full block">
            <Button size="lg" className="w-full gap-2 h-12 text-base">
              <svg className="h-5 w-5" aria-hidden="true" viewBox="0 0 24 24">
                <path
                  d="M12.0003 20.45c4.656 0 8.556-3.21 9.9-7.59h-9.9v-4.14h15.24c.15 1.05.24 2.13.24 3.24 0 8.7-5.82 14.94-15.48 14.94-8.58 0-15.54-6.96-15.54-15.54s6.96-15.54 15.54-15.54c4.02 0 7.65 1.44 10.47 3.84l-3.99 3.99c-1.5-1.35-3.84-2.34-6.48-2.34-5.61 0-10.23 4.29-10.23 9.9s4.62 9.9 10.23 9.9z"
                  fill="currentColor"
                />
              </svg>
              使用 Google 帳號登入
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
